import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { getAnalytics, logEvent, setUserId } from 'firebase/analytics';

import { setIntercomData } from '../../../../utils/intercom';
import { setTrackUser } from '../../../../utils/recordSession';
import { saveAccessToken, saveRefreshToken } from '../../../../utils/token';
import { setClouderType, setUsername } from '../../utils/loginSlice';
import { handleAxiosErrorMessage } from '../../../../utils';
import { encryptUsername, saveUserId } from '../../../../utils/handleUserId';
import makeLogin from './makeLogin';
import env from '../../../../config/env';

export default function useLogin() {
  const analytics = getAnalytics();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ['useLogin'],
    mutationFn: ({ username, password }) => makeLogin({ username, password }),
    onSuccess: async ({ data }, { username, password }) => {
      const {
        accessToken,
        email,
        refreshToken,
        clouderName,
        clouderType,
        username: authenticatedUsername,
      } = data;
      if (password === env.PASSWORD_PLACEHOLDER) {
        sessionStorage.setItem('username', authenticatedUsername);
        navigate('/password-request', { state: { mode: 'first-login' } });
      } else {
        saveAccessToken(accessToken);
        saveRefreshToken(refreshToken);

        localStorage.setItem('clouderType', clouderType);
        dispatch(setClouderType(clouderType));

        setIntercomData({ clouderName, email, username: authenticatedUsername });

        const userId = encryptUsername(authenticatedUsername);

        saveUserId(userId);
        setUserId(analytics, userId);
        logEvent(analytics, 'login');

        setTrackUser({
          userIdentifier: authenticatedUsername,
          additionalInfo: { clouderName },
        });
        dispatch(setUsername(authenticatedUsername));
      }
    },
    onError: (error) => {
      const errorMessage = handleAxiosErrorMessage(error);
      error._customMessage = errorMessage;
    },
  });
}
